module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-white",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 text-center"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "margin-5 no-margin-bottom no-margin-rl"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-phone display-block text-base-color xs-title-large title-extra-large-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "display-block margin-5 no-margin-bottom no-margin-rl text-gray-dark-2 xs-text-large title-small mb50"
  }, [_vm._v(_vm._s(_vm.phone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('div', {
    staticClass: "fb-page",
    attrs: {
      "data-href": 'https://www.facebook.com/' + _vm.facebookUrl,
      "data-tabs": "timeline",
      "data-small-header": "false",
      "data-adapt-container-width": "true",
      "data-hide-cover": "false",
      "data-show-facepile": "false"
    }
  }, [_c('blockquote', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "cite": 'https://www.facebook.com/' + _vm.facebookUrl
    }
  }, [_c('a', {
    attrs: {
      "href": 'https://www.facebook.com/' + _vm.facebookUrl
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.title) + "\n                        ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "display-block font-weight-300 letter-spacing-1 title-large"
  }, [_c('b', [_vm._v("Har du spørgsmål?")]), _c('br'), _vm._v("Kontakt vores erhvervscenter:")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0e9cc44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-sections/contact.vue
// module id = 247
// module chunks = 1